import { Directive, ElementRef, EventEmitter, HostListener, Output, Renderer2 } from '@angular/core';
import { ImageOrientation } from '@sb/library/base';

@Directive({
    selector: '[imageResizer]'
})

export class ImageResizeDirective {

    @Output() orientation = new EventEmitter<ImageOrientation>();

    @HostListener('load') onLoad() {
        this._Renderer.addClass(this.el.nativeElement, this.CalculateOrientationType());
        this._Renderer.removeClass(this.el.nativeElement, 'skeleton_pulse');
    }

    constructor(
        private el: ElementRef,
        private _Renderer: Renderer2
    ) {
        this._Renderer.addClass(this.el.nativeElement, ImageOrientation.RegularHorizontal);
        this._Renderer.addClass(this.el.nativeElement, 'skeleton_pulse');
    }

    CalculateOrientationType(): ImageOrientation {
        const minSquareRatio = 0.75;
        const element = document.getElementById('image-resize');

        if (element && element.clientWidth > element.clientHeight) {
            const ratio = element.clientHeight/element.clientWidth;
            if (ratio < minSquareRatio) {
                return this.ReturnOrientationType(ImageOrientation.LargeHorizontal);
            }
        }
        if (element && element.clientHeight > element.clientWidth) {
            const ratio = element.clientWidth/element.clientHeight;
            if (ratio < minSquareRatio) {
                return this.ReturnOrientationType(ImageOrientation.LargeVertical);
            }
            return this.ReturnOrientationType(ImageOrientation.RegularVertical);
        }
        return this.ReturnOrientationType(ImageOrientation.RegularHorizontal);
    }

    ReturnOrientationType(orientation: ImageOrientation): ImageOrientation {
        this.orientation.emit(orientation);
        return orientation;
    }
}
